import { useScopedTranslate } from '@locale/translate';

import { JourneyAction } from 'api/types';
import { useFlowNodes } from 'ui/journey-builder/hooks/use-nodes';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import {
  JourneyNodeActionCard,
  MoreItems,
  NodeContainer,
} from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

import { getConditionDescription, getConditionTooltip } from './description';
import { useConditionDescription } from './hooks';

type ActionType = 'condition_v2';
export const getDescription = (action: JourneyAction<ActionType>): string => {
  return getConditionDescription({ values: action.values, styled: false });
};

export const Node = (node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  useFlowNodes();

  const values = node.data?.values;
  const isConfigured = node.data?.isConfigured;
  const { descriptionText, isTextClamped } = useConditionDescription(values);
  const description = node.data?.description?.trim();
  const hasDescription = Boolean(description);

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        node={node}
        label={t('title')}
        descriptionText={description || descriptionText}
        {...(isConfigured && {
          tooltip: !hasDescription ? getConditionTooltip({ values, isTextClamped }) : '',
          renderBelowDescription: !hasDescription ? <MoreItems items={values?.conditions} /> : '',
        })}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
};

export const nodeLocale = {
  en: {
    title: 'Condition',
  },
};
